import { render, staticRenderFns } from "./CompanyCodeBadge.vue?vue&type=template&id=62c01d1a"
import script from "./CompanyCodeBadge.vue?vue&type=script&lang=js"
export * from "./CompanyCodeBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports